import { createContext, useContext, useMemo, useState } from "react";
// import products from "../data/products";
import products from "../components/data/products";

const ShopContext = createContext();

export function ShopProvider({ children }) {

    const [category,setCategory]=useState("All");

    const [search,setSearch]=useState("");

    const [sort,setSort]=useState("Newest");

    const [price,setPrice]=useState("");

    const [rating,setRating]=useState("");

    const filteredProducts=useMemo(()=>{

        let data=[...products];

        if(category!=="All"){

            data=data.filter(p=>p.category===category);

        }

        if(search){

            data=data.filter(product=>

                product.name.toLowerCase().includes(search.toLowerCase())

            );

        }

        if(price==="0-20"){

            data=data.filter(p=>p.price<=20);

        }

        if(price==="20-50"){

            data=data.filter(p=>p.price>20 && p.price<=50);

        }

        if(price==="50+"){

            data=data.filter(p=>p.price>=50);

        }

        if(rating){

            data=data.filter(p=>p.rating>=Number(rating));

        }

        switch(sort){

            case "Price Low":

                data.sort((a,b)=>a.price-b.price);

                break;

            case "Price High":

                data.sort((a,b)=>b.price-a.price);

                break;

            case "Rating":

                data.sort((a,b)=>b.rating-a.rating);

                break;

            default:

                break;

        }

        return data;

    },[category,search,sort,price,rating]);

    return(

        <ShopContext.Provider

        value={{

            filteredProducts,

            category,

            setCategory,

            search,

            setSearch,

            sort,

            setSort,

            price,

            setPrice,

            rating,

            setRating

        }}

        >

            {children}

        </ShopContext.Provider>

    )

}

export const useShop=()=>useContext(ShopContext);